// extracted by mini-css-extract-plugin
export default {"form":"CouponForm_form__GSST0","noShrink":"CouponForm_noShrink__4Nz2Z"};